import Vue from 'vue'
import Router from 'vue-router'
import Welcome from './views/Welcome.vue'
import CreateAccount from './views/CreateAccount.vue'
import SetupProfile from './views/SetupProfile.vue'
import Location from './views/Location.vue'
import Done from './views/Done.vue'

import StyleGuide from './views/StyleGuide.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Welcome',
			component: Welcome,
		},
		{
			path: '/account',
			name: 'CreateAccount',
			component: CreateAccount,
		},
		{
			path: '/profile',
			name: 'SetupProfile',
			component: SetupProfile,
		},
		{
			path: '/location',
			name: 'Location',
			component: Location,
		},
		{
			path: '/done',
			name: 'Done',
			component: Done,
		},
		{
			path: '/styleguide',
			name: 'StyleGuide',
			component: StyleGuide,
		},
	],
})
